import { Routes } from '@angular/router';
export const PRIVATE_ROUTES: Routes = [
    { path: 'profile', loadChildren: './profile/profile.module#ProfileModule' },
    { path: 'retailers', loadChildren: './retailer/retailer.module#RetailerModule' },
    { path: 'master-data', loadChildren: './master-data/master-data.module#MasterDataModule' },
    { path: 'salesrep', loadChildren: './salesrep/salesrep.module#SalesrepModule' },
];
